import React, {useEffect, useMemo, useState} from 'react';
import {
    SELECT_DATE_MODAL,
    updateModalRes
} from "@arboxappv4/shared/src/redux/modalManagerSlice";
import {useDispatch, useSelector} from "react-redux";
import {updateToastMessage} from "@arboxappv4/shared/src/redux/stepperSlice";
import {t} from "i18next";

const useMembershipStartDate = (props) => {
    const { values, setFieldValue, handleSubmit, isCart } = props;
    const selectDateRes = useSelector(state => state.modalManager[SELECT_DATE_MODAL].processRes)
    const dispatch = useDispatch()
    const [readyToSubmit, setReadyToSubmit] = useState(false);

    useEffect(() => {
        if(selectDateRes) {
            if(isCart) {
                const newCart = values.cart?.map((item, i) => {
                    if(i === values.cart.length - 1) {
                        if(!item.start) dispatch(updateToastMessage({content: t('cart-item-added', {name: item.name, interpolation: {'escapeValue': false}}), title: t('item-add-success')}))
                        else dispatch(updateToastMessage({content: t('cart-item-updated', {name: item.name, quantity: item.quantity, interpolation: {'escapeValue': false}}), title: t('item-update-success')}))
                        return {...item, start: selectDateRes}
                    }
                    return item
                })
                setFieldValue('cart', newCart)
            } else {
                setFieldValue('cart', [{...values.cart[0], start: selectDateRes}])
            }
            setReadyToSubmit(true)
            dispatch(updateModalRes({modalName: SELECT_DATE_MODAL, res: null}))
        }
    }, [selectDateRes]);

    useEffect(() => {
        if(readyToSubmit && !isCart) {
            handleSubmit(values)
        }
    }, [values.cart, readyToSubmit]);

};

export default useMembershipStartDate;